export { QuantityControlsController as QuantityControls } from './quantity-controls';
